import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { normalizeLocale, SUPPORTED_LOCALES } from "./normalize-locale";

export function LocaleSwitcher() {
  const { i18n, t } = useTranslation();
  const currentLocale = normalizeLocale(i18n.resolvedLanguage);

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    void i18n.changeLanguage(event.target.value);
  };

  return (
    <label className="flex items-center gap-2 text-sm text-muted-foreground">
      <Languages className="h-4 w-4" aria-hidden />
      <span className="sr-only">{t("locale.label")}</span>
      <select
        data-testid="filter-locale"
        value={currentLocale}
        onChange={handleChange}
        className="rounded-md border border-input bg-background px-2 py-1 text-sm"
      >
        {SUPPORTED_LOCALES.map((locale) => (
          <option key={locale} value={locale} data-testid={`filter-locale-${locale}`}>
            {t(`locale.${locale}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
